// extracted by mini-css-extract-plugin
export default {"container":"AddPhotoGalleryPage_container__1m8vy"};